import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LegalPage from '../components/LegalPage';
import { legalConfig } from '../config/legal';
import { renderListItems } from '../utils/legalI18n';

const TermsOfService = () => {
  const { t } = useTranslation('legal');
  const entity = { entityName: legalConfig.entityName, email: legalConfig.contactEmail };

  return (
    <LegalPage title={t('termsTitle')}>
      <p>{t('termsIntro', entity)}</p>

      <h2>{t('termsService')}</h2>
      <p>{t('termsServiceBody')}</p>

      <h2>{t('termsAccounts')}</h2>
      <ul>
        {renderListItems('termsAccountsList', t).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2>{t('termsAcceptableUse')}</h2>
      <p>{t('termsAcceptableUseIntro')}</p>
      <ul>
        {renderListItems('termsAcceptableUseList', t).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2>{t('termsData')}</h2>
      <p>
        {t('termsDataBodyPrefix')}{' '}
        <Link to="/privacy">{t('privacyTitle')}</Link>{' '}
        {t('termsDataBodySuffix')}
      </p>

      <h2>{t('termsAvailability')}</h2>
      <p>{t('termsAvailabilityBody')}</p>

      <h2>{t('termsLiability')}</h2>
      <p>{t('termsLiabilityBody', entity)}</p>

      <h2>{t('termsTermination')}</h2>
      <p>{t('termsTerminationBody')}</p>

      <h2>{t('termsChanges')}</h2>
      <p>{t('termsChangesBody')}</p>

      <h2>{t('termsContact')}</h2>
      <p>
        {t('termsContactBody')}{' '}
        <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
      </p>
    </LegalPage>
  );
};

export default TermsOfService;
